import { useCallback, useMemo, useState } from 'react';

import { PasswordInputIcon } from './PasswordInputIcon';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';

export const PasswordInput = ({ InputProps, ...props }: TextFieldProps) => {
    const [showPassword, setShowPassword] = useState(false);

    const handleClickShowPassword = useCallback(() => setShowPassword(!showPassword), []);
    const handleMouseDownPassword = useCallback(() => setShowPassword(showPassword), []);

    const inputProps = useMemo(
        () => ({
            endAdornment: (
                <InputAdornment position="end">
                    <IconButton
                        aria-label="toggle password visibility"
                        edge="end"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                    >
                        <PasswordInputIcon showPassword={showPassword} />
                    </IconButton>
                </InputAdornment>
            ),
            ...InputProps,
        }),
        [handleClickShowPassword, handleMouseDownPassword, showPassword, InputProps],
    );

    return <TextField type={showPassword ? 'text' : 'password'} InputProps={inputProps} {...props} />;
};
